<script>
export default {
    name: "TestPass",
    props: ['testId', 'currentAttemptId', 'dataProvider', 'userName'],
    data() {
        return {
            loading: true,
            testStarted: false,
            test: null,
            currentQuestion: 0,
            userAnswers: {},
            showResult: false,
            attemptId: null,
            result: null,
            errorText: null,
        }
    },
    created() {
        if (this.testId > 0) {
            this.dataProvider.getTestPass({testId: this.testId}).then((response) => {
                if (response.data.ok) {
                    this.test = response.data.test;

                    this.test.questions.forEach((q) => {
                        const defaultAnswerData = {
                            selectedAnswers: [],
                            answerText: null,
                            showIsCorrect: false,
                            showIsWrong: false,
                            done: false,
                        }
                        this.$set(this.userAnswers, q.id, defaultAnswerData);
                    });

                    if (this.currentAttemptId && this.currentAttemptId > 0) {
                        this.attemptId = this.currentAttemptId;

                        this.dataProvider.getTestAttempt({attemptId: this.attemptId}).then((response) => {
                            if (response.data.ok) {
                                let idx = this.test.questions.findIndex((q) => parseInt(q.id) === parseInt(response.data.attempt.currentQuestionId))

                                if (idx > -1) {
                                    response.data.attempt.userAnswers.forEach((userAnswer) => {
                                        this.$set(this.userAnswers, userAnswer.questionId, {
                                            selectedAnswers: userAnswer.answerId,
                                            answerText: userAnswer.answerText,
                                            showIsCorrect: userAnswer.isCorrect,
                                            showIsWrong: !userAnswer.isCorrect,
                                            done: true,
                                        });
                                    })

                                    this.currentQuestion = idx;
                                } else {
                                    this.currentQuestion = 0;
                                }

                                this.testStarted = true;
                                this.loading = false;
                            } else {
                                this.errorText = this.$t('testAttemptLoadError', {reason: response.data.error || '—'});
                                this.loading = false;
                            }
                        }).catch((error) => {
                            this.errorText = this.$t('testAttemptLoadError', {reason: error.response?.data?.error || error.message});
                            this.loading = false;
                        });
                    } else {
                        this.loading = false;
                    }
                }
            }).catch((error) => {
                this.errorText = this.$t('testLoadError', {reason: error.response?.data?.error || error.message});
                this.loading = false;
            });
        }
    },
    computed: {
        hasQuestions() {
            return Boolean(this.test && Array.isArray(this.test.questions) && this.test.questions.length > 0);
        },
        currentQuestionData() {
            return this.hasQuestions ? (this.test.questions[this.currentQuestion] ?? null) : null;
        },
        prevQuestionDisabled() {
            return this.currentQuestion === 0;
        },
        nextQuestionDisabled() {
            return !this.hasQuestions || this.test.questions.length === this.currentQuestion + 1;
        },
        showIsCorrect: {
            get() {
                return this.currentQuestionData ? (this.userAnswers[this.currentQuestionData.id].showIsCorrect ?? false) : false;
            },
            set(value) {
                if (this.currentQuestionData) {
                    this.$set(this.userAnswers[this.currentQuestionData.id], 'showIsCorrect', value);
                }
            }
        },
        showIsWrong: {
            get() {
                return this.currentQuestionData ? (this.userAnswers[this.currentQuestionData.id].showIsWrong ?? false) : false;
            },
            set(value) {
                if (this.currentQuestionData) {
                    this.$set(this.userAnswers[this.currentQuestionData.id], 'showIsWrong', value);
                }
            }
        },
        done() {
            return this.currentQuestionData ? this.userAnswers[this.currentQuestionData.id].done === true : false;
        }
    },
    methods: {
        goToTestResult() {
            this.$router.push({name: 'tests-result', params: {attemptId: this.attemptId, dataProvider: this.dataProvider}});
        },
        startTest() {
            if (!this.hasQuestions) {
                return;
            }

            let data = {
                testId: this.test.id,
                userName: this.userName,
            }

            const response = this.dataProvider.startTest(data);
            response.then((res) => {
                if (res.data.ok) {
                    this.attemptId = res.data.attemptId;
                    this.testStarted = true;
                } else if (res.data.error === 'no_questions') {
                    this.errorText = this.$t('testNoQuestionsMessage');
                } else {
                    this.errorText = this.$t('testStartError', {reason: res.data.error || '—'});
                }
            }).catch((error) => {
                if (error.response?.data?.error === 'no_questions') {
                    this.errorText = this.$t('testNoQuestionsMessage');
                } else {
                    this.errorText = this.$t('testStartError', {reason: error.response?.data?.error || error.message});
                }
            })
        },
        prevQuestion() {
            if (this.currentQuestion > 0) {
                this.currentQuestion--;
            }
        },
        nextQuestion() {
            if (this.hasQuestions && this.currentQuestion + 1 < this.test.questions.length) {
                this.currentQuestion++;
            }
        },
        answer() {
            if (!this.currentQuestionData) {
                return;
            }

            let data = {
                attemptId: this.attemptId,
                questionId: this.currentQuestionData.id,
                answerId: this.userAnswers[this.currentQuestionData.id].selectedAnswers,
                answerText: this.userAnswers[this.currentQuestionData.id].answerText,
            }

            const response = this.dataProvider.answer(data);
            response.then((res) => {
                if (res.data.ok) {
                    this.$set(this.userAnswers[this.currentQuestionData.id], 'done', true);
                    this.$set(this.userAnswers[this.currentQuestionData.id], 'showIsCorrect', res.data.isCorrect);
                    this.$set(this.userAnswers[this.currentQuestionData.id], 'showIsWrong', !res.data.isCorrect);
                }
            });
        },
        finish() {
            if (this.currentQuestionData && this.currentQuestion === this.test.questions.length - 1) {
                let data = {
                    attemptId: this.attemptId,
                };

                this.dataProvider.finish(data).then((response) => {
                    if (response.data.ok) {
                        this.goToTestResult();
                    }
                });
            }
        },
    }
}
</script>

<template>
    <v-container v-if="this.loading === true">
        <v-row>
            <v-col>
                <v-progress-linear indeterminate></v-progress-linear>
            </v-col>
        </v-row>
    </v-container>
    <v-container v-else-if="errorText">
        <v-row>
            <v-col>
                <v-alert type="error" text>
                    {{ errorText }}
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
    <v-container fluid v-else>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        {{ this.test.title }}
                    </v-card-title>
                    <v-card-text>
                        <v-alert v-if="!hasQuestions" type="warning" text>
                            {{ $t('testNoQuestionsMessage') }}
                        </v-alert>
                        <div v-else-if="this.testStarted === false">
                            <div>
                                <froalaView v-model="this.test.description"></froalaView>
                            </div>
                        </div>
                        <div v-else-if="currentQuestionData">
                            <v-row>
                                <v-col cols="12">
                                    <div>
                                        Вопрос {{ currentQuestion + 1}}/{{ test.questions.length }}
                                    </div>
                                    <div>
                                        <h1>{{ currentQuestionData.questionText }}</h1>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <div v-if="currentQuestionData.type === 'single'">
                                        Возможен только один вариант ответа.
                                    </div>
                                    <div v-if="currentQuestionData.type === 'multi'">
                                        Возможно несколько вариантов ответа.
                                    </div>
                                    <div v-if="currentQuestionData.type === 'open'">
                                        Запишите ваш ответ.
                                    </div>
                                    <div v-if="currentQuestionData.type !== 'open'">
                                        <div v-for="(answer, index) in currentQuestionData.answers" :key="index">
                                            <v-checkbox
                                                v-model="userAnswers[currentQuestionData.id].selectedAnswers"
                                                :value="answer.id"
                                                :label="answer.answerText"
                                                :multiple="currentQuestionData.type === 'multi'"
                                                :disabled="done"
                                            ></v-checkbox>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <v-textarea
                                            v-model="userAnswers[currentQuestionData.id].answerText"
                                            outlined
                                            label="Ваш ответ"
                                        ></v-textarea>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <div v-if="showIsCorrect">
                                        Ответ верный.
                                    </div>
                                    <div v-if="showIsWrong">
                                        <div v-if="currentQuestionData.wrongAnswerText && currentQuestionData.wrongAnswerText.length > 0">
                                            {{ currentQuestionData.wrongAnswerText }}
                                        </div>
                                        <div v-else>
                                            Ответ неверный.
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn
                                        @click="answer"
                                        color="primary"
                                        :disabled="done"
                                    >
                                        Ответить
                                    </v-btn>
                                    <v-btn
                                        v-if="this.currentQuestion === this.test.questions.length - 1"
                                        @click="finish"
                                        color="primary"
                                    >
                                        Завершить тест
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn @click="prevQuestion" :disabled="prevQuestionDisabled">
                                        Предыдущий вопрос
                                    </v-btn>
                                    <v-btn @click="nextQuestion" :disabled="nextQuestionDisabled">
                                        Следующий вопрос
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                            </v-row>
                        </div>
                    </v-card-text>
                    <v-card-actions v-if="this.testStarted === false && hasQuestions">
                        <v-btn @click="startTest">Начать тест</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped>

</style>
